export const SET_LOADING = 'SET_LOADING'
export const SET_PERFIL = 'SET_PERFIL'